export enum Country {
  FINLAND = "FINLAND",
  SWEDEN = "SWEDEN",
}
